<template>
	<ul>
		<li v-for="link in links" :key="link.name">
			<router-link :to="link.link" :class="link.active ? 'a' : ''">{{ link.name }}</router-link>
			<div class="arrow" v-if="!link.active"></div>
		</li>
	</ul>
</template>

<script>
export default {
	props: ['links'],
	data() {
		return {};
	}
};
</script>

<style scoped>
ul {
	list-style: none;
	padding: 20px 0 !important;
	margin: 0;
}
li {
	display: inline-block;
}
li a {
	padding: 0 10px;
	text-decoration: none;
	font-size: 13px;
	color: grey;
}
.arrow {
	display: inline-block;
	width: 5px;
	height: 5px;
	margin-bottom: 1px;
	transform: rotate(135deg);
	border-right: 1px solid grey;
	border-bottom: 1px solid grey;
}
.a {
	color: var(--black-color);
	font-size: 13px;
	font-family: changeMedium;
}
</style>
